import { paths } from 'src/routes/paths';

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

export const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL}/`;
